//
//
//
//
//
//
//
//
//
//
//

import CdnImage from "../Image/CdnImage";
import Wrapper from "../Layout/Wrapper";
import Alignable from "../../mixins/Alignable";

export default {
name: "AppFeatureButtons",
    components: {Wrapper, CdnImage},
    mixins: [Alignable]
}
